import TwitterPixel from './TwitterPixel';

export default TwitterPixel;
